import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useEffect, useRef } from 'react';

export default function BasicLayout() { // 헤더 푸터를 모든 페이지에 두기 위한 베이직 레이아웃

  const location = useLocation();
  const timerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (timerRef.current) clearTimeout(timerRef.current);

      timerRef.current = setTimeout(() => {
        // 현재 문서의 모든 .reveal 중 화면에 있는 것들을 다시 찾음
        const allReveals = document.querySelectorAll(".reveal:not(.show)");
        const visibleTargets = Array.from(allReveals).filter(el => {
          const rect = el.getBoundingClientRect();
          // 화면 안에 있는지 판별 (threshold 0.15와 유사한 조건)
          return rect.top < window.innerHeight && rect.bottom > 0;
        });

        // 필터링된 보이는 요소들에게만 순차 딜레이 부여
        visibleTargets.forEach((el, i) => {
          el.style.animationDelay = `${i * 0.15}s`;
          el.classList.add("show");
        });
      }, 200); 
    }, { threshold: 0.2 });

    document.querySelectorAll(".reveal").forEach(el => observer.observe(el));
    
    return () => {
      observer.disconnect();
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [location]); // 페이지 이동 시 재실행

  return (
    <div id="wrap">
      <Header />
      <div id="container">
        <Outlet/>
      </div>
      <Footer />
    </div>
  );
}
